import React from 'react'
import type { SimplifiedSiteStatus } from '../../shared/api/executive-monitoring.api'

interface StatsOverviewProps {
  stats: {
    working: number
    problem: number
    notWorking: number
    total: number
    uptime: string
  }
  sites: SimplifiedSiteStatus[]
  activeMetric?: 'working' | 'problem' | 'not_working'
}

export const StatsOverview: React.FC<StatsOverviewProps> = ({ 
  stats, 
  sites,
  activeMetric = 'working'
}) => {
  const getActiveSites = () => {
    switch (activeMetric) {
      case 'working':
        return sites.filter(site => site.status === 'working')
      case 'problem':
        return sites.filter(site => site.status === 'problem')
      case 'not_working':
        return sites.filter(site => site.status === 'not_working')
      default:
        return []
    }
  }

  const activeSites = getActiveSites()

  return (
    <div className="bg-white/70 dark:bg-gray-800/70 backdrop-blur-xl rounded-2xl p-6 border border-white/20 dark:border-gray-700/30">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100">
          Детальная статистика
        </h3>
        <div className="text-sm text-gray-500 dark:text-gray-400">
          Активна метрика: <span className="font-medium text-gray-700 dark:text-gray-300">
            {activeMetric === 'working' ? 'Работают' : 
             activeMetric === 'problem' ? 'Проблемы' : 'Не работают'}
          </span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-gray-50 dark:bg-gray-900/50 rounded-xl p-4">
          <div className="text-sm text-gray-500 dark:text-gray-400 mb-1">Всего сайтов</div>
          <div className="text-2xl font-bold text-gray-900 dark:text-gray-100">
            {stats.total}
          </div>
        </div>

        <div className="bg-gray-50 dark:bg-gray-900/50 rounded-xl p-4">
          <div className="text-sm text-gray-500 dark:text-gray-400 mb-1">Доступность</div>
          <div className="text-2xl font-bold text-emerald-600 dark:text-emerald-400">
            {stats.uptime}%
          </div>
        </div>

        <div className="bg-gray-50 dark:bg-gray-900/50 rounded-xl p-4">
          <div className="text-sm text-gray-500 dark:text-gray-400 mb-1">
            {activeMetric === 'working' ? 'Работают' : 
             activeMetric === 'problem' ? 'С проблемами' : 'Не работают'}
          </div>
          <div className={`text-2xl font-bold ${
            activeMetric === 'working' ? 'text-emerald-600 dark:text-emerald-400' :
            activeMetric === 'problem' ? 'text-amber-600 dark:text-amber-400' :
            'text-rose-600 dark:text-rose-400'
          }`}>
            {activeSites.length}
          </div>
        </div>

        <div className="bg-gray-50 dark:bg-gray-900/50 rounded-xl p-4">
          <div className="text-sm text-gray-500 dark:text-gray-400 mb-1">Загружено</div>
          <div className="text-2xl font-bold text-blue-600 dark:text-blue-400">
            {sites.length}
          </div>
        </div>
      </div>
    </div>
  )
}